import { FC } from "react";
import styles from "@/styles/pages/software.module.scss";
import { Col, Row } from "react-bootstrap";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import { CgArrowRight } from "react-icons/cg";

export const SubServiceCard: FC<{
  section: { title: string; content: string; breif?: string; img: StaticImageData; demo?: string };
}> = ({ section: { title, content, breif, img, demo } }) => {
  return (
    <Row className={`text-center text-lg-start ${styles.card}`}>
      <Col
        xl={3}
        lg={4}
        className={`${styles.shape} d-flex justify-content-center align-items-center `}
      >
        <div className={`${styles.images} `}>
          <Image src={img} alt={`${title} image`} className='w-100 h-auto  ms-2' />
        </div>
      </Col>
      <Col xl={9} lg={8} className={`${styles.content}`}>
        <h2>{title}</h2>
        <h3>{breif}</h3>
        <p>{content}</p>
        {demo ? (
          <Link className='text-white d-flex align-items-center read-more' href={demo}>
            View Demo
            <span className='position-relative d-flex justify-content-center align-items-center'>
              <CgArrowRight className='ms-1 my-auto' />
              <CgArrowRight className='ms-1 my-auto position-absolute' />
            </span>
          </Link>
        ) : null}
      </Col>
    </Row>
  );
};
